/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsefulAppConfigurationModel } from '../../models/useful-app-configuration-model';

export interface GetUsefulAppConfiguration$Params {
  systemMaterialNumber?: number;
  modalityId?: number;
  country?: string;
  magnetType?: string;
}

export function getUsefulAppConfiguration(http: HttpClient, rootUrl: string, params?: GetUsefulAppConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<UsefulAppConfigurationModel>> {
  const rb = new RequestBuilder(rootUrl, getUsefulAppConfiguration.PATH, 'get');
  if (params) {
    rb.query('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.query('modalityId', params.modalityId, {});
    rb.query('country', params.country, {});
    rb.query('magnetType', params.magnetType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsefulAppConfigurationModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getUsefulAppConfiguration.PATH = '/api/systemoverview/usefulappconfiguration';
getUsefulAppConfiguration.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getUsefulAppConfiguration.ROOTURL = '/portal';
